module.exports = __webpack_public_path__ + "img/shop-jd.1dbd9a4c.png";